<template>
    <div class="mx-auto header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('aube-coin.staking.confirmTitle') }}</h3>
        </div>

        <form @submit.prevent="handleOnSubmit">
            <!-- Forthing送金設定 -->
            <div class="setting-box">
                <label class="setting-title">{{ $t('aube-coin.staking.forthingSettingTitle') }}</label>
                :
                <label class="label-value">{{ getForthingLabel(this.aube_coin_forthing_setting) }}</label>
            </div>

            <!-- EX BONUS送金設定 -->
            <div v-if="showRemittanceBonusSetting" class="setting-box">
                <label class="setting-title">{{ $t('aube-coin.staking.exBonusSettingTitle') }}</label>
                :
                <label class="label-value">{{ getExBonusLabel(this.aube_coin_ex_bonus_setting) }}</label>
            </div>

            <div class="setting-box">
                <label class="confirm-msg">{{ $t('aube-coin.staking.ConfirmMessageText') }}</label>
            </div>

            <div class="text-center">
                <div class="pb-4 ">
                    <button type="button" class="btn btn-primary" @click="back">{{ $t('aube-coin.staking.btnBackText') }}</button>
                    <button type="submit" class="btn btn-primary">{{ $t('aube-coin.staking.btnUpdateText') }}</button>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
    import AubeCoinStakingService from '../../services/AubeCoinStakingService'
import { MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD } from '../../utils/Const';

    export default {
        name: 'aube-coin-automatic-remittance-confirm',

        data() {
            return {
                aube_coin_forthing_setting: '',
                aube_coin_ex_bonus_setting: '',
                memberTypeId: undefined,
            }
        },

        async mounted() {
        },

        created() {
            this.getConfirmData();
        },

        computed: {
            showRemittanceBonusSetting() {
                if (this.memberTypeId === null || this.memberTypeId === undefined) {
                    return false;
                }
                const memberTypes = [MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD];
                return !memberTypes.includes(this.memberTypeId);
            }
        },

        methods: {
            getForthingLabel(value) {
                switch(Number(value)) {
                    case 0:
                        return this.$t('aube-coin.staking.offLabel');
                    case 1:
                        return this.$t('aube-coin.staking.oneYearsLabel');
                    case 2:
                        return this.$t('aube-coin.staking.twoYearsLabel');
                    case 3:
                        return this.$t('aube-coin.staking.threeYearsLabel');
                    case 5:
                        return this.$t('aube-coin.staking.fiveYearsLabel');
                    default:
                        return this.$t('aube-coin.staking.offLabel');
                }
            },
            getExBonusLabel(value) {
                switch(Number(value)) {
                    case 0:
                        return this.$t('aube-coin.staking.offLabel');
                    case 1:
                        return this.$t('aube-coin.staking.oneYearsLabel');
                    case 2:
                        return this.$t('aube-coin.staking.twoYearsLabel');
                    case 3:
                        return this.$t('aube-coin.staking.threeYearsLabel');
                    case 5:
                        return this.$t('aube-coin.staking.fiveYearsLabel');
                    default:
                        return this.$t('aube-coin.staking.offLabel');
                }
            },
            async getConfirmData() {
                if(sessionStorage.formData){
                    this.formData = JSON.parse(sessionStorage.formData);
                    this.aube_coin_forthing_setting = Number(this.formData.aube_coin_forthing_setting);
                    this.aube_coin_ex_bonus_setting = Number(this.formData.aube_coin_ex_bonus_setting);
                    this.memberTypeId = Number(this.formData.memberTypeId);
                } else {
                    // セッションストレージが存在しない場合ログイン後トップ画面に遷移
                    this.$router.push('/');
                }

            },
            back: function(event){
                this.$router.push('/aube-coin-staking/automatic-remittance');
            },
            async handleOnSubmit() {
                try {
                        this.aube_coin_forthing_setting_data = String(this.aube_coin_forthing_setting);
                        this.aube_coin_ex_bonus_setting_data = String(this.aube_coin_ex_bonus_setting);

                        var data =
                        {
                            "forting" : {"plan" : this.aube_coin_forthing_setting_data},
                            "exbonus" : {"plan" : this.aube_coin_ex_bonus_setting_data}
                        };
                        // 自動送付設定登録処理
                        const result_data = (await AubeCoinStakingService.setReserveAubeCoinStakingSettingHistory(data)).data;

                        if(result_data.result === true) {
                            // sessionStorageの削除処理
                            sessionStorage.removeItem('formData')
                            // 完了画面へ遷移
                            this.$router.push('/aube-coin-staking/automatic-remittance-complete');
                        }
                } catch (err) {
                }
            },
        }
    }
</script>

<style scoped>
    .form-group {
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .setting-box{
        text-align:center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .label-value {
        width: 60px;
        text-align: left;
    }
    .setting-title{
        width: 220px;
        text-align: center;
    }
    .confirm-msg{
        text-align: center;
        margin-top: 10px;
    }
    .btn-primary {
        width: 115px;
        margin-top: 10px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    @media (min-width: 992px){
        .col-lg-4 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    @media (min-width: 768px){
        .col-md-6 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    @media (min-width: 576px){
        .col-sm-12 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
</style>
